import BaseActions from '@/store/base/actions'
import Schema from './schema'

const module = 'users'

export default BaseActions({module}, {
  //
}, [Schema])